const TRENDING_STORIES =
  'https://www.texastribune.org/api/v1/content/most_viewed/?format=json&limit=5';

export { TRENDING_STORIES };



// WEBPACK FOOTER //
// ./utils/feeds.js